import { PkAvatar, PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useHref } from 'react-router';

import { getImageUrl, getArrVideos } from '../../utils/misc';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';
import VideoPlayer from '@shared/VideoPlayer';
import { isReferrerFromDomain } from '@utilities/url';

import * as styles from './styles.module.scss';

const trackingData = {
  category: 'Click',
  action: 'Go back',
  label: 'navigation',
};

export const Header = ({ playerData, editorialInfo, kind, fromMain }) => {
  const t = useTranslateFn();

  const player = playerData.player;
  const team = playerData.team;
  const imageUrl = getImageUrl(playerData, editorialInfo);
  const arrVideos = player && getArrVideos(playerData, editorialInfo);
  const video = player && arrVideos?.length && { ...arrVideos[0], imageUrl };
  const { isDesktopExtraLarge } = useWindowSize();
  const linkHref = useHref('/');
  const divStyle = {
    ...(imageUrl && { backgroundImage: `url(${imageUrl})` }),
  };

  // do not print button if referrer is internal
  const domain = location.hostname === 'localhost' ? 'localhost' : '.uefa.com';
  return (
    <div
      style={divStyle}
      className={clsx(
        styles.tsPlayerHeader,
        styles[`ts-player-header--${kind}`],
        team?.typeIsNational && ['ts-player-header--team', `team-${player.countryCode.toUpperCase()}`],
      )}
    >
      <div className={clsx(styles.tsPlayerHeaderWrap, 'ts-player-header-wrap')}>
        {!fromMain && !isReferrerFromDomain(domain) && (
          <PkButton
            data-tracking={JSON.stringify(trackingData)}
            className={clsx(styles.pkButton, 'js-tracking-link')}
            appearance='text'
            linkRel='prev'
            linkHref={linkHref}
          >
            <PkIcon name='navigation-chevron-left' />
            {t('go_back')}
          </PkButton>
        )}
        {kind === 'placeholder' && (
          <>
            <div className={styles.tsPlayerPhoto}>
              <PkAvatar
                fallback-image='generic-head'
                type='image'
                size={isDesktopExtraLarge ? 192 : 96}
                src={player.imageUrl}
              />
            </div>
            <div className={styles.tsPlayerName}>
              <div className={styles.tsPlayerFirstname}>{player.firstName}</div>
              <div className={styles.tsPlayerLastname}>{player.lastName}</div>
            </div>
          </>
        )}
        {kind === 'photo' && (
          <div className={styles.tsPlayerName}>
            <div className={styles.tsPlayerFirstname}>{player.firstName}</div>
            <div className={styles.tsPlayerLastname}>{player.lastName}</div>
          </div>
        )}
        {kind === 'video' && <div className={styles.tsPlayerVideoWrap}>{video && <VideoPlayer teaser={video} />}</div>}
      </div>
    </div>
  );
};

export default Header;
